import { Link } from 'react-router-dom';

/**
 * 404 page displayed for unknown routes.
 */
export function NotFoundPage(): React.ReactElement {
  return (
    <main className="flex min-h-screen items-center justify-center bg-portal-bg px-4">
      <div className="space-y-4 text-center">
        <h1 className="text-portal-page tracking-[-1.7px]">404</h1>
        <p className="text-portal-small text-portal-muted">Page not found</p>
        <Link
          to="/"
          className="inline-block h-[43px] rounded-portal-button bg-brand px-4 leading-[43px] text-portal-tiny font-bold text-white"
        >
          Go home
        </Link>
      </div>
    </main>
  );
}
